export interface VentaDetalle {
  factura: any;
  detalles: FacturaDetalleItem[];
  comprobanteElectronico: any | null;
}

export interface FacturaDetalleItem {
  idFacturaDetalle: number;
  idArticulo: number | null;
  descripcion: string | null;
  unidadMedida: string | null;
  cantidad: number;
  precioUnitario: number;
  precioSinIGV: number;
  descuento: number;
  porcentajeDescuento: number | null;
  subTotal: number;
  igv: number;
  total: number;
  idLote: number | null;
  idDeposito: number | null;
  afectaStock: boolean;
  numeroLinea: number;
  codigoProductoSunat: string | null;
  tipoAfectacionIGV: string | null;
}

export interface VentaCreateRequest {
  idComprobante: number;
  idPersona: number;
  idVendedor?: number | null;
  idSucursal?: number | null;
  serie: string;
  idTipoVenta?: number | null;
  idListaPrecio?: number | null;
  incluyeIGV: boolean;
  porcentajeIGV?: number | null;
  direccionEntrega?: string | null;
  guiaRemision?: string | null;
  ordenCompra?: string | null;
  fechaVencimiento?: string | null;
  idCotizacion?: number | null;
  idOrdenPedido?: number | null;
  observaciones?: string | null;
  detalles: VentaDetalleCreateRequest[];
}

export interface VentaDetalleCreateRequest {
  idArticulo: number;
  descripcion: string;
  unidadMedida?: string | null;
  cantidad: number;
  precioUnitario: number;
  precioCosto?: number | null;
  descuento?: number | null;
  porcentajeDescuento?: number | null;
  idLote?: number | null;
  idDeposito?: number | null;
  afectaStock: boolean;
  codigoProductoSunat?: string | null;
  tipoAfectacionIGV?: string | null;
}

export interface VentaFormErrors {
  idComprobante?: string;
  idPersona?: string;
  serie?: string;
  detalles?: string;
}

export const initialVentaCreate: VentaCreateRequest = {
  idComprobante: 0,
  idPersona: 0,
  serie: '',
  incluyeIGV: true,
  porcentajeIGV: 18,
  detalles: [],
};
